import { subDays } from "date-fns";
import type { ObserverIssueInfo } from "../../../api/observerTypes";

const appInsightsResources = {
  default: {
    name: "ai-webservices-prod-001",
    resourceGroup: "rg-shared-prod-001",
  },
  bcPublicApi: {
    name: "ai-bc-public-api-prod-001",
    resourceGroup: "rg-core-prod-001",
  },
};

const subscriptionId = "a2feef4c-9014-49ad-8372-c94f1f675645";

const getAppInsightsResource = (issue: ObserverIssueInfo) =>
  issue.service?.toLowerCase().includes("bc public api") || issue.service?.toLowerCase().includes("bc api")
    ? appInsightsResources.bcPublicApi
    : appInsightsResources.default;

const getTransactionDetailsUrl = (issue: ObserverIssueInfo) => {
  if (!issue.appInsightsTraceId) {
    return undefined;
  }

  const resource = getAppInsightsResource(issue);
  const dataModel = {
    eventId: issue.appInsightsTraceId,
    timestamp: issue.appInsightsTimestampUtc ?? issue.runAtUtc,
  };
  const componentId = {
    Name: resource.name,
    ResourceGroup: resource.resourceGroup,
    SubscriptionId: subscriptionId,
  };

  return `https://portal.azure.com/#blade/AppInsightsExtension/DetailsV2Blade/DataModel/${encodeURIComponent(JSON.stringify(dataModel))}/ComponentId/${encodeURIComponent(JSON.stringify(componentId))}`;
};

const getTransactionSearchUrl = (issue: ObserverIssueInfo) => {
  if (!issue.exampleOperationId) {
    return undefined;
  }

  const resource = getAppInsightsResource(issue);
  const resourceId = `/subscriptions/${subscriptionId}/resourceGroups/${resource.resourceGroup}/providers/microsoft.insights/components/${resource.name}`;
  const endTime = new Date(issue.runAtUtc);
  const startTime = subDays(endTime, 1);
  const timeContextWhereClause = `| where timestamp > datetime("${startTime.toISOString()}") and timestamp < datetime("${endTime.toISOString()}")`;
  const operationFilter = `| where operation_Id == "${issue.exampleOperationId}" | order by timestamp desc`;
  const bladeInputs = {
    tables: ["requests", "exceptions", "traces", "dependencies", "pageViews"],
    timeContextWhereClause,
    filterWhereClause: operationFilter,
    originalParams: {
      eventTypes: [
        { value: "request", tableName: "requests", label: "Request" },
        { value: "exception", tableName: "exceptions", label: "Exception" },
        { value: "trace", tableName: "traces", label: "Trace" },
        { value: "dependency", tableName: "dependencies", label: "Dependency" },
        { value: "pageView", tableName: "pageViews", label: "Page View" },
      ],
      timeContext: {
        durationMs: endTime.getTime() - startTime.getTime(),
        endTime: endTime.toISOString(),
      },
      filter: [],
      searchPhrase: {
        originalPhrase: issue.exampleOperationId,
        _tokens: [
          {
            conjunction: "and",
            value: issue.exampleOperationId,
            isNot: false,
            kql: ` * has "${issue.exampleOperationId}"`,
          },
        ],
      },
      sort: "desc",
    },
  };

  return `https://portal.azure.com/#blade/AppInsightsExtension/BladeRedirect/BladeName/searchV1/ResourceId/${encodeURIComponent(resourceId)}/BladeInputs/${encodeURIComponent(JSON.stringify(bladeInputs))}`;
};

export const getAppInsightsTransactionUrl = (issue: ObserverIssueInfo) =>
  getTransactionDetailsUrl(issue) ?? getTransactionSearchUrl(issue);
